import React from "react";
import kindo from "../imgs/kindo.gif"

export default function Kindo() {
  return (
    <img src={kindo} alt="Kindo"/>
  )
}
